import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { DotChartOutlined, TableOutlined } from '@ant-design/icons';
import { message, Tabs } from 'antd';
import { getErrorMessages, getReportMessages } from '../../../../constants/messages';
import { DownloadCustomPriceReport, getClientLeasedDevicesService } from '../../actions';
import CustomPriceGraph from '../CustomPriceGraph';
import LeasedServicePriceReport from './LeasedServicePriceReport';

let errorMessages = getErrorMessages(),
	reportMessages = getReportMessages();

const messages = {
	...errorMessages,
	...reportMessages,
};

const LeasedServicePricePage = () => {
	const intl = useIntl();
	const [clients, setClients] = useState([]);
	const [loading, setLoading] = useState(false);
	const leasedServiceCode = 'S0019';

	useEffect(() => {
		(async () => {
			try {
				setLoading(true);
				const response = await getClientLeasedDevicesService();
				setClients(response);
			} catch (error) {
				message.error(intl.formatMessage({ ...messages.commonError }));
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	const downloadReport = () => {
		setLoading(true);
		DownloadCustomPriceReport(clients, leasedServiceCode)
			.then(() => message.success(intl.formatMessage({ ...messages.exportSuccess })))
			.catch(() => message.error(intl.formatMessage({ ...messages.exportError })))
			.finally(() => setLoading(false));
	};

	const items = [
		{
			key: '1',
			label: <TableOutlined />,
			children: <LeasedServicePriceReport clients={clients} loading={loading} downloadReport={downloadReport} />,
		},
		{
			key: '2',
			label: <DotChartOutlined />,
			children: <CustomPriceGraph clients={clients} />,
		},
	];

	return (
		<div className="view">
			<Tabs defaultActiveKey="1" items={items} />
		</div>
	);
};

export default LeasedServicePricePage;
